//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OmnichannelCommand: any = {
    PostUpdateStorePickup: Backofficebff + '/v1/omnichannel/updateStorePickup',
    PostUpsertStoreCapacity: Backofficebff + '/v1/omnichannel/upsertStoreCapacity',
    PostUpdateServieceManagment: Backofficebff + '/v1/omnichannel/set-storestatus',
    SaveOperationFlagValue: Backofficebff + '/v1/omnichannel/SaveOperationFlagValue',
};
